import React from 'react'

/** NFC RWA Ashoka Park emblem — asset in `frontend/public/nfc-rwa-ashoka-park-logo.png`. */
export const NFC_RWA_LOGO_PATH = '/nfc-rwa-ashoka-park-logo.png'

export const NFC_RWA_LOGO_ALT =
  'New Friends Colony Residential Welfare Association (NFC RWA) Ashoka Park'

type NfcRwaLogoProps = {
  className?: string
}

export const NfcRwaLogo: React.FC<NfcRwaLogoProps> = ({ className = '' }) => (
  <img
    src={NFC_RWA_LOGO_PATH}
    alt={NFC_RWA_LOGO_ALT}
    className={`object-contain ${className}`.trim()}
    decoding="async"
  />
)
